export default __webpack_public_path__ + "static/media/SuccesImg.f24179a4.svg";